import { ApexOptions } from "apexcharts";
import React from "react";
import Chart from "react-apexcharts";

interface ResumoProps {
    totalPlanejadas: number;
    totalExecutadas: number;
    totalAtrasadas: number;
    totalParaHoje: number;
}

export default function PainelResumo({
    totalAtrasadas,
    totalExecutadas,
    totalParaHoje,
    totalPlanejadas,
}: ResumoProps) {
    const series = [
        {
            name: "Atividades",
            data: [
                totalPlanejadas,
                totalExecutadas,
                totalAtrasadas,
                totalParaHoje,
            ],
        },
    ];

    const options: ApexOptions = {
        chart: {
            type: "bar",
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: [
                `${totalPlanejadas} Planejadas`,
                `${totalExecutadas} Executadas`,
                `${totalAtrasadas} Atrasadas`,
                `${totalParaHoje} Para o Dia`,
            ],
        },
        yaxis: {
            title: {
                text: "Total",
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: function (val: number) {
                    return `${val} atividades`;
                },
            },
        },
    };

    return (
        <div className="">
            <h5>Resumo de Atividades</h5>
            <div>
                <div className="row">
                    <div className="col-12">
                        <Chart
                            options={options}
                            series={series}
                            type="bar"
                            height={300}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
